import { createSlice } from '@reduxjs/toolkit'

// Setup the initial state

const initialState = {
  insertSpouseRelation: {},
  insertRepRelation: {},
  insertRepresentativeRelation: {},
  consultSpouseRelation: {},
  consultRepresentativeRelation: {},
  updateRepresentativeRelation: {},
  deleteRelation: {},
};

export const relationsSlice = createSlice({
  name: 'relations',
  initialState,
  reducers: {

    // Insert Spouse Relation

    setInsertSpouseRelationLoading: (state) => {
      state.insertSpouseRelation = {
        isLoading: true,
      };
    },

    setInsertSpouseRelationSuccess: (state) => {
      state.insertSpouseRelation = {
        success: true
      };
    },

    setInsertSpouseRelationFailure: (state, action) => {
      state.insertSpouseRelation = {
        error: action.payload,
      }
    },

    clearInsertSpouseRelation: (state) => {
      state.insertSpouseRelation = {}
    },

    // Insert Representative Relation

    setInsertRepRelationLoading: (state) => {
      state.insertRepRelation = {
        isLoading: true,
      };
    },

    setInsertRepRelationSuccess: (state) => {
      state.insertRepRelation = {
        success: true
      };
    },

    setInsertRepRelationFailure: (state, action) => {
      state.insertRepRelation = {
        error: action.payload,
      }
    },

    clearInsertRepRelation: (state) => {
      state.insertRepRelation = {}
    },

    // Insert Representative Data

    setInsertRepresentativeRelationLoading: (state) => {
      state.insertRepresentativeRelation = {
        isLoading: true,
      };
    },

    setInsertRepresentativeRelationSuccess: (state) => {
      state.insertRepresentativeRelation = {
        success: true
      };
    },

    setInsertRepresentativeRelationFailure: (state, action) => {
      state.insertRepresentativeRelation = {
        error: action.payload,
      }
    },

    clearInsertRepresentativeRelation: (state) => {
      state.insertRepresentativeRelation = {}
    },


    // Consult Spouse Relation

    setConsultSpouseRelationLoading: (state) => {
      state.consultSpouseRelation = {
        isLoading: true,
      };
    },

    setConsultSpouseRelationSuccess: (state, action) => {
      state.consultSpouseRelation = {
        data: action.payload,
      };
    },

    setConsultSpouseRelationFailure: (state, action) => {
      state.consultSpouseRelation = {
        error: action.payload,
      }
    },

    clearConsultSpouseRelation: (state) => {
      state.consultSpouseRelation = {}
    },


    // Consult Representative Relation

    setConsultRepresentativeRelationLoading: (state) => {
      state.consultRepresentativeRelation = {
        isLoading: true,
      };
    },

    setConsultRepresentativeRelationSuccess: (state, action) => {
      state.consultRepresentativeRelation = {
        data: action.payload,
      };
    },

    setConsultRepresentativeRelationFailure: (state, action) => {
      state.consultRepresentativeRelation = {
        error: action.payload,
      }
    },

    clearConsultRepresentativeRelation: (state) => {
      state.consultRepresentativeRelation = {}
    },


    // Update Representative Relation

    setUpdateRepresentativeRelationLoading: (state) => {
      state.updateRepresentativeRelation = {
        isLoading: true,
      };
    },

    setUpdateRepresentativeRelationSuccess: (state) => {
      state.updateRepresentativeRelation = {
        success: true,
      };
    },

    setUpdateRepresentativeRelationFailure: (state, action) => {
      state.updateRepresentativeRelation = {
        error: action.payload,
      }
    },

    clearUpdateRepresentativeRelation: (state) => {
      state.updateRepresentativeRelation = {}
    },


    // Delete Relation

    setDeleteRelationLoading: (state) => {
      state.deleteRelation = {
        isLoading: true,
      };
    },

    setDeleteRelationSuccess: (state) => {
      state.deleteRelation = {
        success: true,
      };
    },

    setDeleteRelationFailure: (state, action) => {
      state.deleteRelation = {
        error: action.payload,
      }
    },

    clearDeleteRelation: (state) => {
      state.deleteRelation = {}
    },

  },
})

export const {
  setInsertSpouseRelationLoading, setInsertSpouseRelationSuccess, setInsertSpouseRelationFailure, clearInsertSpouseRelation,
  setInsertRepRelationLoading, setInsertRepRelationSuccess, setInsertRepRelationFailure, clearInsertRepRelation,
  setInsertRepresentativeRelationLoading, setInsertRepresentativeRelationSuccess, setInsertRepresentativeRelationFailure, clearInsertRepresentativeRelation,
  setConsultSpouseRelationLoading, setConsultSpouseRelationSuccess, setConsultSpouseRelationFailure, clearConsultSpouseRelation,
  setConsultRepresentativeRelationLoading, setConsultRepresentativeRelationSuccess, setConsultRepresentativeRelationFailure, clearConsultRepresentativeRelation,
  setUpdateRepresentativeRelationLoading, setUpdateRepresentativeRelationSuccess, setUpdateRepresentativeRelationFailure, clearUpdateRepresentativeRelation,
  setDeleteRelationLoading, setDeleteRelationSuccess, setDeleteRelationFailure, clearDeleteRelation,
} = relationsSlice.actions

export default relationsSlice.reducer;